import { ServiceTime, ServiceTimeKindType } from '@ancon/wildcat-types'

/** Whether the order is for a set time (unlike ASAP), and that time is known */
export default function isScheduledServiceTime(
  serviceTime: ServiceTime | null | undefined,
) {
  return (
    serviceTime?.kind === ServiceTimeKindType.AtSpecifiedTime &&
    !!serviceTime.time
  )
}
